// Utility functions for asset form

import dayjs from 'dayjs';

// Constants
export const DEFAULT_TECH_LABELS = ['Thương hiệu', 'Model', 'Thông tin mô tả', 'Tiêu thụ', 'Năng suất'];

// Types
export interface TechSpecsItem {
  key: string;
  value: string;
}

// Utility functions
export const processTechnicalSpecifications = (techSpecs: any): Record<string, string | number> => {
  const techSpecsObj: Record<string, string | number> = {};
  
  // Đảm bảo luôn có 5 trường
  for (let idx = 0; idx < 5; idx++) {
    const item = techSpecs[idx];
    const label = DEFAULT_TECH_LABELS[idx];
    
    // Với Form.List sử dụng name trực tiếp, item sẽ là giá trị string
    let value = '';
    if (typeof item === 'string') {
      value = item;
    } else if (item && typeof item === 'object' && item.value !== undefined) {
      value = item.value;
    } else if (item !== undefined && item !== null) {
      value = String(item);
    }
    
    if (idx === 0 || idx === 1) {
      techSpecsObj[label] = (value && value.trim() !== '') ? value : '—';
    } else if (idx === 2) {
      techSpecsObj[label] = value || '—';
    } else if (idx === 3 || idx === 4) {
      techSpecsObj[label] = (value && value !== '') ? Number(value) : 0;
    }
  }
  
  return techSpecsObj;
};

export const formatDateForAPI = (date: any): string | undefined => {
  if (!date) return undefined;
  return dayjs(date).format('YYYY-MM-DD');
};

export const calculateTotalAccessoriesValue = (accessories: any[]): number => {
  return accessories.reduce((total, accessory) => {
    const totalPrice = accessory.total_price || ((accessory.price || 0) * (accessory.quantity || 0)) || 0;
    return total + totalPrice;
  }, 0);
};

export const getTabMapForValidation = (): Record<string, string> => ({
  company_id: '1',
  asset_code: '1',
  name: '1',
  category_id: '1',
  location_id: '1',
  status: '1',
  parent_asset_id: '1',
  description: '1',
  technical_condition: '1',
  technical_specifications: '2',
  maintenance_types: '3',
  maintenance_cycles: '3',
  images: '4',
  documents: '4',
  accessories: '5',
});

export const filterListByCompany = <T extends { company_id: number }>(
  list: T[],
  companyId: number
): T[] => {
  return list.filter(item => item.company_id === companyId);
}; 